<template>
  <div class="venue-card flex" :class="type">
    <div class="card-image">
      <w-navigation
        :object="venue"
        :params="{
          name: 'VenueProfile',
          params: {
            slug: venue.slug
          }
        }"
        :is-link="isLink"
        :blank="openExternal"
      >
        <template #link>
          <img
            :src="getImageUrl(venue)"
            :alt="venue.name"
            class="main-image"
            loading="lazy"
            @error="
              $event.target.src = require('@/assets/images/venue-placeholder.svg')
            "
          />
        </template>
      </w-navigation>
    </div>
    <div
      class="card-info w-1/2 flex flex-col justify-between pl-3 pt-3 pb-2 flex-1"
    >
      <div class="info">
        <w-navigation
          :object="venue"
          :params="{
            name: 'VenueProfile',
            params: {
              slug: venue.slug
            }
          }"
          :blank="openExternal"
          :is-link="isLink"
        >
          <template #link>
            <h3 class="name text-start font-museo-700">
              {{ venue.name }}
            </h3>
          </template>
        </w-navigation>
        <p v-if="isFilterPage && venue.city" class="city-data">
          {{ venue.city.name
          }}<span>, {{ venue.city.administrative_division }}</span>
        </p>
        <p
          class="venue-concerts text-start text-xs font-museo-300"
          :class="type === 'small' ? 'mt-0' : 'mt-2'"
        >
          {{ venue.events_count }} {{ $t("general.concerts") }}
        </p>
      </div>
      <div class="actions  font-museo-700 text-s text-color-topaz-light mr-4">
        <follow-button :item="venue" type="venue" theme="text" :size="type" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import FollowButton from "@/components/general/FollowButton.vue";
import WNavigation from "@/components/general/ui/WNavigation";
import { useRoute } from "vue-router";

// TODO: añadir los composables necesarios
defineProps({
  isLink: {
    type: Boolean,
    default: true
  },
  venue: {
    type: Object,
    default: undefined
  },
  type: {
    type: String,
    default: "base"
    // TODO: Falta definirlo (Probablemente big o small)
  },
  openExternal: {
    type: Boolean,
    default: false
  }
});
defineEmits(["follow"]);

const route = useRoute();

const isFilterPage = computed(() => {
  return (
    (route.name === "FilterVenues" || route.query.type === "venues") &&
    route.name === "FiltersPageCountry"
  );
});

const getImageUrl = element => {
  if (element?.thumbnails_v4?.s_cd) return element.thumbnails_v4.s_cd;
  if (element?.thumbnails?.s_cd) return element.thumbnails.s_cd;
  if (element?.image_url) return element.image_url;
  return require("@/assets/images/venue-placeholder.svg");
};
</script>

<style scoped lang="scss">
.venue-card {
  background-color: #1c1d29;
  width: 378px;
  height: 158px;
  border-radius: 6px;
  overflow: hidden;
  .card-image {
    img {
      width: 158px;
      height: 158px;
      object-fit: cover;
    }
  }
  .card-info {
    color: $white;
    font-size: 1rem;
    .actions p {
      color: $topaz;
    }
  }
  &.base {
    width: 378px;
    height: 158px;
  }
  &.small {
    height: 96px;
    width: 250px;
    .card-info {
      font-size: 12px;
      .actions p {
        font-size: 12px;
      }
    }
    img {
      height: 96px;
      width: 104px;
    }
    .venue-concerts {
      font-size: 10px;
    }
    @media screen and (max-width: $screen-md) {
      width: 197px;
      height: 78px;
      img {
        height: 78px;
        width: 78px;
      }
      .card-info {
        font-size: 11px;
      }
    }
  }
  &.medium {
    width: 283px;
    height: 120px;
    img {
      height: 120px;
      width: 120px;
    }
    .card-info {
      font-size: 12px;
      padding-bottom: 1rem;
      p {
        font-size: 10px;
      }
    }
  }
  .venue-concerts {
    font-size: 14px;
  }
}
.city-data {
  font-size: 0.75rem;
}
</style>
